import { httpRequest } from '../../shared/lib/utils/httpClient';
import { rowsPerPage } from '../../pages/constants';

export interface OpsStaffList {
  totalRecords: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  opsStaffList: OpsStaff[];
}

export interface OpsStaff {
  id: number;
  opsStaffBusinessId: string | null;
  userName: string | null;
  firstName: string | null;
  lastName: string | null;
  assignedTo: string | null;
  status: string | null;
  role: string | null;
  email: string | null;
  createdOn: string | null;
}

export interface OpsStaffRoles {
  id: number;
  name: string;
}

export interface OpsStaffMetaData {
  roles: OpsStaffRoles[];
}

export interface OpsStaffData {
  id: number;
  userBusinessId: string;
  firstName: string;
  lastName: string;
  status: boolean;
  primaryEmail: string;
  roleId: number;
  notes: string;
}

type GetOpsStaffListParams = Readonly<{
  page?: number;
  size?: number;
  sortField?: string;
  sortType?: string;
  searchTerm?: string;
  statusId?: number[];
  roleId?: number[];
}>;

export const getOpsStaffList = async (
  options: GetOpsStaffListParams = {}
): Promise<OpsStaffList> => {
  const {
    page = 0,
    size = rowsPerPage,
    sortField,
    sortType,
    searchTerm,
    statusId,
    roleId,
  } = options;

  const params: Record<string, string | number> = {
    page,
    size,
  };

  const userId = localStorage.getItem('userId') ?? '0';

  if (sortField) params.sortField = sortField;
  if (sortType) params.sortType = sortType;
  if (searchTerm) params.searchTerm = searchTerm;
  if (statusId?.length) params.statusId = statusId.join(',');
  if (roleId?.length) params.roleId = roleId.join(',');

  const response = await httpRequest<OpsStaffList>({
    method: 'GET',
    url: '/operation/ops-staffs',
    params,
    headers: { userId },
  });

  return response;
};

export const getOpsStaffMetaData = async (
  userId: string
): Promise<OpsStaffMetaData> => {
  const response = await httpRequest<OpsStaffMetaData>({
    method: 'GET',
    url: `/operation/ops-staff/metadata`,
    headers: { userId },
  });
  return response;
};

export const saveOrUpdateOpsStaff = async (
  userId: string,
  action: string,
  payload: OpsStaffData
) => {
  const apiAction = action === 'Save' ? 'SAVE' : 'UPDATE';
  const response = await httpRequest<OpsStaffData>({
    method: 'PUT',
    url: `/operation/ops-staff?action=${apiAction}`,
    headers: { userId },
    data: payload,
  });
  return response;
};

export const getOpsStaffDetailsById = async (
  userId: string,
  opsStaffId: number
): Promise<OpsStaffData> => {
  const response = await httpRequest<OpsStaffData>({
    method: 'GET',
    url: `/operation/ops-staff?opsStaffId=${opsStaffId}`,
    headers: { userId },
  });
  return response;
};
